declare namespace $ {

	type $mol_link__arg_shm_projects_card_1 = $mol_type_enforce<
		ReturnType< $shm_projects_card['project_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__sub_shm_projects_card_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_view__sub_shm_projects_card_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_card_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_card_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_link__arg_shm_projects_card_6 = $mol_type_enforce<
		ReturnType< $shm_projects_card['project_prerelease_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__sub_shm_projects_card_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_view__sub_shm_projects_card_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_card_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_card_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_card_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_card_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_card_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_projects_card extends $mol_view {
		project_arg( ): Record<string, any>
		project_title( ): string
		Project_title( ): $mol_link
		project_version( ): string
		Project_version( ): $mol_view
		Head( ): $mol_view
		Prerelease_label( ): $mol_view
		project_prerelease_arg( ): Record<string, any>
		project_prerelease( ): string
		Prerelease_link( ): $mol_link
		Prerelease( ): $mol_view
		Release_label( ): $mol_view
		project_release( ): string
		Release( ): $mol_view
		Channels( ): $mol_view
		Updated_label( ): $mol_view
		project_version_date( ): string
		Updated( ): $mol_view
		project_id( ): string
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=card.view.tree.d.ts.map